import React from "react";
import { Colors } from "../../utils/colors";
import { SelectCircleCollapsedHeader } from "../selectCircleCollapsedHeader/SelectCircleCollapsedHeader";
import { observer } from "mobx-react-lite";
import { SelectedPlayersList } from "../selectedPlayersList/SelectedPlayersList";
import { GuestPlayersList } from "../guestPlayersList/GuestPlayersList";
import { SelectedCircleInCollapsed } from "../selectedCircleInCollapsed/SelectedCircleInCollapsed";
import { ExcludedPlayersInCollapsed } from "../excludedPlayersInCollapsed/ExcludedPlayersInCollapsed";
import { useSelectCircleStore } from "../../stores/StoreContext";

type props = {};

export const SelectCircleCollapsed: React.FC<props> = observer(() => {
  const selectCircleStore = useSelectCircleStore();
  return (
    <div
      style={{
        backgroundColor: Colors.green,
        borderRadius: 20,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        paddingTop: 20,
        marginTop: 20,
        // marginLeft: 10,
        // marginRight: 10,
      }}>
      <SelectCircleCollapsedHeader />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}>
        <SelectedPlayersList />
        <GuestPlayersList />
      </div>
      <div style={{ height: 20 }} />
      {selectCircleStore.selectedCircles.length > 0 &&
        selectCircleStore.selectedCircles.map((circle, index) => {
          return <SelectedCircleInCollapsed circle={circle} />;
        })}
      <ExcludedPlayersInCollapsed />
    </div>
  );
});
